import PaymentMethodsProvider from './PaymentMethods.provider';

export default PaymentMethodsProvider;
